import _ from 'lodash'
import qs from 'qs'
import { createAction, createReducer } from 'redux-act'
import { baseUrl } from '../scripts/env'
import message from 'antd/lib/message'

import { fetchStat } from 'ducks/summary'
import { fetch as fetchWithdrawals } from 'ducks/withdrawals'
import axios from 'axios'
import l8n from 'l8n'

const REDUCER = 'pay_license'
const NS = `@@${REDUCER}/`

export const CASE_CONFIRMATION = 'confirmation'
export const CASE_CONFIRM_ERROR = 'confirm_error'
export const CASE_CURRENCY_MISMATCH = 'currency_mismatch_error'
export const CASE_NOT_ENOUGH_REWARD = 'not_enough_reward_error'
export const CASE_UNKNOWN_ERROR = 'unknown_error'
export const CASE_TRANSACTION_NOT_FOUND = 'transaction_not_found_error'
export const CASE_UNACCEPTABLE_LICENSE_TYPE = 'unacceptable_license_type_error'
export const CASE_UNACCEPTABLE_TRANSACTION_STATUS = 'unacceptable_transaction_status_error'

export const setTransactionId = createAction(`${NS}SET_TRANSACTION_ID`)

export const reset = createAction(`${NS}RESET`)
export const dialog = createAction(`${NS}DIALOG`)
export const setCase = createAction(`${NS}CASE`)

export const createRequest = createAction(`${NS}CREATE_REQUEST`)
export const createSuccess = createAction(`${NS}CREATE_SUCCESS`)
export const createFailure = createAction(`${NS}CREATE_FAILURE`)

const initialState = {
    _case: CASE_CONFIRMATION,
    allowed: true,
    dialog: false,
    isSending: false,
    transaction_id: null
}

export const create = params => async (dispatch) => {
    dispatch(createRequest())
    const response = await axios({
        method: 'POST',
        url: `${baseUrl}/${REDUCER}`,
        data: qs.stringify(params)
    })
    
    if (_.get(response, 'data.ok', false) === false) {
        const _case = _.get(response, 'data.error_list', false) ? _.first(response.data.error_list) : CASE_UNKNOWN_ERROR
        dispatch(setCase(_case))
        dispatch(createFailure())
        return false
    }

    message.success(l8n.p_withdraw_request_confirmed_h)
    dispatch(reset())
    dispatch(dialog(false))
    dispatch(fetchWithdrawals())
    dispatch(fetchStat())
    return true
}

export default createReducer(
  {
    [reset]: (state) => ({ ...state, _case: CASE_CONFIRMATION, allowed: true, dialog: false, isSending: false }),
    [dialog]: (state, dialog) => ({ ...state, dialog }),
    [setCase]: (state, _case) => {
        let allowed = true
        switch (_case) {
            case CASE_CURRENCY_MISMATCH:
            case CASE_NOT_ENOUGH_REWARD:{ allowed = false; break }
            default:{ allowed = true }
        }
        return {...state, _case, isSending: false, allowed} 
    },

    [setTransactionId]: (state, transaction_id) => ({ ...state, transaction_id }),

    [createRequest]: (state) => ({ ...state, isSending : true }),
    [createSuccess]: (state) => ({ ...state, isSending : false }),
    [createFailure]: (state) => ({ ...state, isSending : false }),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/pay_license.js